/**
 * What a caught value should say to a person.
 *
 * ⚠️ THE SERVER'S MESSAGE WINS, ALWAYS, and this is the one place that rule is
 * written down. It used to be spelled out at the call sites — `caught instanceof
 * Error ? caught.message : '…'`, thirty-five times, in nine files — and a single
 * one of them getting it backwards would replace a precise 409 («на это время
 * уже есть событие этой активности») with a generic «не удалось».
 *
 * ⚠️ THE FALLBACK IS FOR WHEN THERE IS NOTHING BETTER, NOT A DEFAULT. Every API
 * failure arrives as an `ApiError`, which carries the server's own sentence and
 * is the actionable half. The fallback covers the two cases where nothing usable
 * exists: a thrown non-Error, and an `Error` whose message is empty or blank —
 * `toApiError` cannot produce one, but a `TypeError` from a bad cast can, and a
 * toast with no text in it is indistinguishable from a bug in the toast.
 *
 * ⚠️ NO IMPORTS, DELIBERATELY. Every tested module in this frontend is one that
 * pulls in neither React nor HeroUI — see `lib/schedule.ts` — because the test
 * runner here is Bun with no DOM. Putting this beside the toast helpers that USE
 * it would have made it untestable for the sake of one fewer file.
 */
export function errorText(caught: unknown, fallback: string): string {
  if (caught instanceof Error && caught.message.trim() !== '') return caught.message;
  return fallback;
}
